import { onMounted, onUnmounted, ref, shallowRef } from 'vue'

export function usePickerOptions<T>(load: (signal: AbortSignal) => Promise<T[]>, onError: (error: unknown) => void) {
  const options = shallowRef<T[]>([])
  const isLoading = ref(true)
  const controller = new AbortController()

  onMounted(async () => {
    try {
      options.value = await load(controller.signal)
    } catch (error) {
      if (controller.signal.aborted) return
      console.error('Failed to load picker options:', error)
      onError(error)
    } finally {
      isLoading.value = false
    }
  })

  onUnmounted(() => controller.abort())

  return { options, isLoading }
}
